import { Navigate, Outlet } from "react-router-dom";
import type { UserRole } from "@dosa/types";
import { useAuth } from "../hooks/useAuth";
import { PageLoading } from "@dosa/ui";

/**
 * Client-side route gating for UX only (hiding nav a user shouldn't see). It is NOT a
 * security boundary: apps/worker enforces role checks and resource-ownership authorization
 * server-side on every request, independent of what the client renders. See SECURITY.md.
 */
export function RequireRole({ roles }: { roles: UserRole[] }) {
  const { user, isLoading } = useAuth();

  if (isLoading) return <PageLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to="/login" replace />;

  return <Outlet />;
}
